import { createContext, useContext } from "react";

export const PageContext = createContext({ pageLoading: false });
export const usePage = () => {
  const page = useContext(PageContext);
  return page;
};
